import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import GridHelper from "../helpers/gridHelper";
import FilterBar from "../common/FilterBar";

// Matches the backend's actual filter semantics (UserRepository.SelectAsync): firstName/
// lastName/email use Contains(), lastAuthenticatedWith/isAdmin/isSuperUser are all
// single-value equality checks against a small fixed set of options — hence FilterBar's
// 'select' type (a dropdown, "Any" or exactly one value) rather than 'multiselect' (which
// would send a comma-joined list the backend can't parse for these fields).
const filterDefs = [
  {
    key: "firstName",
    label: "First Name",
    type: "text",
    operators: [{ value: "contains", label: "Contains" }],
  },
  {
    key: "lastName",
    label: "Last Name",
    type: "text",
    operators: [{ value: "contains", label: "Contains" }],
  },
  {
    key: "email",
    label: "Email",
    type: "text",
    operators: [{ value: "contains", label: "Contains" }],
  },
  {
    key: "lastAuthenticatedWith",
    label: "Last Authenticated With",
    type: "select",
    operators: [{ value: "equals", label: "Equals" }],
    options: [
      { value: "CloudSync", label: "CloudSync" },
      { value: "Okta", label: "Okta" },
    ],
  },
  {
    key: "isAdmin",
    label: "Is Admin",
    type: "select",
    operators: [{ value: "equals", label: "Equals" }],
    options: [
      { value: "true", label: "Yes" },
      { value: "false", label: "No" },
    ],
  },
  {
    key: "isSuperUser",
    label: "Is Super User",
    type: "select",
    operators: [{ value: "equals", label: "Equals" }],
    options: [
      { value: "true", label: "Yes" },
      { value: "false", label: "No" },
    ],
  },
];

function UsersGridFilter(props) {
  const location = useLocation();
  const navigate = useNavigate();

  const applyFilter = (nextFilter) => GridHelper.handleSearch(nextFilter, location, navigate);

  return <FilterBar filterDefs={filterDefs} value={props.filter} onChange={applyFilter} />;
}

export default UsersGridFilter;
